module.exports = __webpack_public_path__ + "media/images/landing/second/photo10-70c717c70776489a977a15cf72cd61f3.jpg";